/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };
//# sourceMappingURL=speechace-carousel.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/speechace-carousel/speechace-carousel.component.scss.shim.ngstyle.js
// module id = 1647
// module chunks = 27 28 29